module.exports = __webpack_public_path__ + "media/images/top/top_pickup_company_03-c26d3c23b37cf4b6493922bb8f3805a7.png";